import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import TravelCompaniesPage from './travel-companies'

const travelCompanyRoutes: Route[] = [
  {
    path: Paths.SETTING_TRAVEL_COMPANIES,
    element: <TravelCompaniesPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default travelCompanyRoutes
